import Button from "elements/Button";
import { formatPrice, titleShorten } from "utils/Formatter";

export default function ProductBody({ listProduct, menu }) {
  console.log(listProduct);
  return (
    <div className="row">
      {listProduct.isLoading
        ? "Loading..."
        : listProduct.map((item, index) => {
            return (
              <div className="col-4" key={index}>
                <div className="card">
                  <figure className="img-wrapper">
                    <img
                      src={item ? item.image : ""}
                      alt={item.name}
                      className="img-fluid"
                    />
                  </figure>
                  <div className="meta-wrapper">
                    <Button
                      type="link"
                      href={`/product/${item.id}`}
                      className="stretched-link d-block"
                    >
                      <h5 className="title">
                        {titleShorten(item.name, 40, " ")}{" "}
                      </h5>
                    </Button>
                    <p>{item.categories.name}</p>
                    <h5>Rp. {formatPrice(item.price)}</h5>
                  </div>
                </div>
              </div>
            );
          })}
    </div>
  );
}
